import { type ReactElement } from 'react'
import { observer } from 'mobx-react-lite'
import { PageScroll } from 'app/components/layout/PageScroll'
import { PageHeaderComponent } from 'app/components/page-header/PageHeaderComponent'
import { useWorkspace } from 'app/utils'
import { OpsEvalsProvider } from './OpsEvalsContext'
import { EvalsPanelComponent } from './EvalsPanelComponent'

export const OpsEvalsLayoutComponent = observer(function OpsEvalsLayoutComponent(): ReactElement {
  const workspaceId = useWorkspace()?.id

  return (
    <PageScroll
      header={
        <PageHeaderComponent
          title="Evals"
          subTitle="Run prompts against golden datasets to verify accuracy improves and does not regress."
        />
      }
      contentClassName="pb-14 pt-6"
    >
      <OpsEvalsProvider key={workspaceId} workspaceId={workspaceId}>
        <EvalsPanelComponent />
      </OpsEvalsProvider>
    </PageScroll>
  )
})
